// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yn4Fs","right":"styles_right__2eUQ7"};